<template>
    <div>
        <Box  @close="cerrar(false)" :width="'800px'">
            <template #top>Registrar Mixer</template>
            <template #center>
                <div class="nj-card">
                    <div class="nj-cols form c2">
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_nombre">
                        </div>
                        <div>
                            <div class="nj-label">Placa</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_placa">
                        </div>
                        <div>
                            <div class="nj-label">Capacidad</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_capacidad">
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="registrar()"><i class=" mdi-content-save"></i>Registrar</button>
            </template>
        </Box>
    </div>
</template>
<script>
import Toast from "../../util/toast"
import { Buttons, Box } from "../components"
import { ResponseStatus, MixerService } from "../../rest"

export default {
    name: "RegistrarMixer",
    components: {
        Box,
        Buttons
    },
    data() {
        return {
            mixer: {
                mix_nombre: null,
                mix_capacidad: null,
                mix_placa: null,
            }
        }
    },
    methods: {
        registrar() {
            MixerService.registrar({
                mixer: this.mixer
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.cerrar(true)
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        cerrar(condition) {
            this.$emit("close", { componente: 'registrar', abrir: false, buscar: condition })
        }
    },
    mounted() {

    }
}
</script>

<style scoped></style>